import Axios from "axios";
import { headerConfig } from "../helpers/services.helper";

export function replaceDotWithComma(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function formatDecimal(num) {
  return (
    num
      .toString()
      //.toFixed(2) // always two decimal digits
      .replace(".", ",") // replace decimal point character with ,
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
  ); // use . as a separator
}

export function formatInt(num) {
  return Number(num)
    .toFixed(0)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
}

export function downloadFile(link, filename) {
  const config = {
    headers: headerConfig,
    responseType: "blob"
  };
  Axios(link, config).then(response => {
    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", filename);
    document.body.appendChild(fileLink);
    fileLink.click();
    document.body.removeChild(fileLink);
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      URL.revokeObjectURL(fileURL);
    }, 100);
  });
}

export function getSvgAreaClasses(cssClass) {
  const result = [];
  let className = "";

  className = `svg-area-${cssClass}`;

  result.push(className);
  return result;
}

export function round(num) {
  return Math.round(num * 100) / 100;
}
